<template>
  <div id="container">
    <label>Select Master Stock Code</label>
    <masterCodeField v-model="masterStockCode" />
    <vs-divider>Add Sub Stock Code</vs-divider>
    <form v-if="masterStockCode">
      <div class="vx-row mb-2">
        <template v-for="(fName, indexTd) in dataStructure">
          <div v-if="fName.showInForm == 'yes'" class="vx-col sm:w-1/2 w-full mb-1">
            <vs-input class="w-full" v-validate="'required'" :label-placeholder="fName.label" :name="fName.colName"
              v-model="data[fName.colName]" />
            <span class="text-danger text-sm" v-show="errors.has(fName.colName)">{{ errors.first(fName.colName) }}</span>
          </div>
        </template>


      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button type="filled" @click.prevent="submitForm" class="mt-5 block">Submit</vs-button>
        </div>
      </div>
    </form>

  </div>
</template>
<script>
import masterCodeField from './masterCodeField.vue';
import { axiosMixin } from '@/mixin/axiosMixin.js';
export default {
  mixins: [axiosMixin],
  components: {
    masterCodeField
  },
  data() {
    return {
      test: '',
      masterStockCode: '',
      subStockCode: '',
      size: '',
      endPoint: 'substockcodes',
      operation: 'add',
      subCodeId: '',
      data: {},
      dataStructure: []
    }
  },
  watch: {
    masterStockCode: function (val) {
      this.data.masterStockCode = val.id;
    }
  },
  mounted() {
    this.getFields();
  },
  methods: {
    startLoading() {
      this.disableSubmitBtn = false;
      this.$vs.loading({
        container: "#container",
        scale: 0.6
      });
    },
    stopLoading() {
      this.disableSubmitBtn = true;
      this.$vs.loading.close("#container > .con-vs-loading");
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.startLoading();
          this.aronPostPut(
            this.endPoint,
            this.operation,
            this.data,
            this.subCodeId
          )
            .then(response => {
              //this.$router.push("/" + this.getCallBack).catch(() => {});

              if (this.operation == "add") {
                this.$emit("addnew", {
                  response: response.data,
                  view: "list"
                });
              } else {
                this.$emit("updateRow", {
                  response: response.data,
                  view: "view"
                });
              }
              this.stopLoading();
            })
            .catch(error => {
              console.error("error from : update profile_edit. reason:", error);
              this.stopLoading();
            });
        } else {
          // form have errors
        }
      })
    },
    getFields() {
      var params = "page1&per_page=10";
      var sort = "&sort_by=id&sort_direction=asc";
      this.startLoading();
      this.aronGet(this.endPoint, params, sort)
        .then(response => {
          this.dataStructure = response.data.fields;
          //loop this.dataStructure and put the index into an object name data
          this.dataStructure.forEach((item, index) => {
            this.data[item.colName] = '';
          });
          this.stopLoading();
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
          this.stopLoading();
        });
    },

  }
}
</script>
